import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { PROBLEMS } from '../data/content';
export function Problems() {
  return <section className="px-5 py-10" data-id="element-118">
      <div className="mx-auto max-w-md" data-id="element-119">
        <h2 className="text-center font-anton text-2xl leading-tight text-white sm:text-3xl" data-id="element-120">
          Probablemente algo de esto te suene familiar 🫩
        </h2>

        <div className="mt-6 space-y-3" data-id="element-121">
          {PROBLEMS.map((p, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.5
        }} transition={{
          duration: 0.4,
          delay: i * 0.06
        }} className="flex items-start gap-3 rounded-xl border border-white/10 bg-[#111]/90 px-4 py-3.5" data-id="element-122">
              <AlertTriangleIcon className="mt-0.5 h-5 w-5 shrink-0 text-[#F5C518]" data-id="element-123" />
              <p className="text-[15px] leading-snug text-neutral-200" data-id="element-124">{p}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}